export function normalizeString(str: string): string {
  return str.replace(/\s+/g, '').toLowerCase();
}
